(function() {
    'use strict';
    angular
        .module('trakeyeApp')
        .factory('TrWorkOrderType', TrWorkOrderType);

    TrWorkOrderType.$inject = ['$resource', 'DateUtils'];

    function TrWorkOrderType ($resource, DateUtils) {
        var resourceUrl =  'api/trworkorder-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('TrWorkOrderTypeSearch', ['$rootScope','$http',function($rootScope,$http){

       var service ={};
	   service.getTrWorkOrderTypebyname = function (data,callback){
		$http.get('api/trworkorder-types-details/'+data).then(function(response){
    	    callback(response.data);
    	});
	};
	
	return service;
    }]);
})();
(function () {
    'use strict';

    angular
        .module('trakeyeApp')
        .factory('TrWorkOrderTypeSearch', TrWorkOrderTypeSearch);

    TrWorkOrderTypeSearch.$inject = ['$resource'];

    function TrWorkOrderTypeSearch ($resource) {
        var service = $resource('/api/trworkorder-types/searchvalue/:userId',{userId:'@id'},{},{
            'query': {method: 'GET',isArray: true},
        });

        return service;
    }
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('AllCustomTrWorkOrderTypeAttribute', [ '$rootScope', '$http', function($rootScope, $http) {

		var service = {};
		service.getAll = function(callback) {
			$http.get('api/all-custom-trworkorder-type-attributes').then(function(response) {
				callback(response.data);
			});
		};

		return service;
	} ]);
})();